import styled from "styled-components/macro";
import {
  DPIconFacebook,
  // DPIconFacebookTwo,
  // DPIconHomeTwo,
  DPIconInstagram,
  // DPIconInstagramTwo,
  // DPIconMailTwo,
  // DPIconTelephone,
} from "../../assets/icons";
import Typography from "../../atoms/typography";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import media from "../../constants/MediaQuery";
import Theme from "../../constants/Theme";

const ContactUs = () => {
  return (
    <CUStyling className="container">
      <div className="cu-design" />
      <div className="ContactUs__CUStyling__CU-container container">
        <div className="ContactUs__CUStyling__CU-container--contact-us">
          <Typography.Heading
            color="darkBlue"
            weight="bold"
            capitalize
            level={1}
          >
            Contact us
          </Typography.Heading>
          <div className="ContactUs__CUStyling__CU-container--contact-us--bcs-container">
            <div className="ContactUs__CUStyling__CU-container--contact-us--bcs-container--bcs-el">
              <Typography.Heading
                className="cu-title"
                color="darkBlue"
                fontType="Galano Alt"
                level={5}
              >
                Business Address
              </Typography.Heading>
              <Typography.Text className="cu-text">
                {" "}
                {/* <DPIconHomeTwo className="icons" />{" "} */}
                <span>
                  366, Muritala Mohammed Way, MJS Building, (opposite Polaris
                  bank), Yaba Bus-stop, Lagos State.
                </span>
              </Typography.Text>
            </div>
            <div className="ContactUs__CUStyling__CU-container--contact-us--bcs-container--bcs-el">
              <Typography.Heading
                className="cu-title"
                color="darkBlue"
                fontType="Galano Alt"
                level={5}
              >
                Contacts
              </Typography.Heading>
              <Typography.Text className="cu-text">
                {/* <DPIconMailTwo className="icons" />{" "} */}
                <span>hello@dotpay.africa</span>
              </Typography.Text>
              <Typography.Text className="cu-text">
                {/* <DPIconTelephone className="icons" /> */}
                <span>+2348061971534 and +2348061908723</span>
              </Typography.Text>
            </div>
            <div className="ContactUs__CUStyling__CU-container--contact-us--bcs-container--bcs-el">
              <Typography.Heading
                className="cu-title"
                color="darkBlue"
                fontType="Galano Alt"
                level={5}
              >
                Social media
              </Typography.Heading>
              <div style={{ display: "flex" }}>
                <DPIconFacebook className="icons" />
                <DPIconInstagram />
              </div>
            </div>{" "}
          </div>
        </div>
        <div className="ContactUs__CUStyling__CU-container--form-container">
          <div>
            <Typography.Heading
              className="landing--text-summary"
              color="pending"
              weight="medium"
              level={3}
              uppercase
              fontType="Galano"
            >
              Get in touch
            </Typography.Heading>
            <Typography.Heading
              className="ContactUs__CUStyling__CU-container--form-heading"
              color="darkBlue"
              fontType="Galano"
              weight="medium"
              level={1}
            >
              Send a message
            </Typography.Heading>
          </div>
          <form
            onSubmit={(e) => e.preventDefault()}
            className="ContactUs__CUStyling__CU-container--cu-form"
          >
            <div className="ContactUs__CUStyling__CU-container--cu-form--row-spacing">
              <Typography.Text
                className="ContactUs__CUStyling__CU-container--cu-form--row-spacing--cu-heading"
                // level={4}
                color="matteBlack"
                capitalize
              >
                Name
              </Typography.Text>
              <Input placeholder="Enter your name" />
            </div>
            <div className="ContactUs__CUStyling__CU-container--cu-form--row-spacing">
              <Typography.Text
                className="ContactUs__CUStyling__CU-container--cu-form--row-spacing--cu-heading"
                // level={4}
                color="matteBlack"
                capitalize
              >
                Email address
              </Typography.Text>
              <Input placeholder="Enter your Email address" />
            </div>
            <div className="ContactUs__CUStyling__CU-container--cu-form--row-spacing">
              <Typography.Text
                className="ContactUs__CUStyling__CU-container--cu-form--row-spacing--cu-heading"
                // level={4}
                color="matteBlack"
                capitalize
              >
                Message
              </Typography.Text>
              <Input placeholder="Type message" />
            </div>
            <Button
              type="submit"
              className="ContactUs__CUStyling__CU-container--cu-btn"
              primary
              text="Submit"
            />
          </form>
        </div>
      </div>
    </CUStyling>
  );
};
const CUStyling = styled.div`
  display: flex;
  padding: 50px 0;
  font-family: ${Theme.typography.secondary};

  .icons {
    margin: 0 10px 10px 0;
  }
  .cu-text {
    display: flex;
    line-height: 26px;
  }
  .cu-title {
    padding: 10px 0;
    font-size: ${Theme.fontSizes.large};
  }
  .cu-design {
    display: none;
    width: 372px;
    position: relative;
    top: 80px;
    height: 63px;
    background: linear-gradient(
      197.92deg,
      #ef8031 -227.37%,
      rgba(239, 128, 49, 0.307045) 1.58%,
      rgba(239, 128, 49, 0) 103.02%
    );
    ${media.tabletMin` display: none;`}
    ${media.smallDesktopMin` display: block;`}
  }
  .ContactUs__CUStyling {
    position: relative;
    &__CU-container {
      position: relative;
      margin: 0;
      display: flex;
      flex-direction: column;
      &--contact-us {
        &--bcs-container {
          &--bcs-el {
            padding: 5px 0;
            &--cu-title {
              padding: 10px 0;
              font-size: ${Theme.fontSizes.large};
            }
          }
        }
      }
      ${media.smallDesktopMin`
      flex-direction: row;
      align-items: center;
     `};
      &--form-container {
        max-width: 360px;
        width: 100%;
        margin-top: 20px;
      }
      &--form-heading {
        font-size: 35px;
      }
      &--contact-us {
        ${media.smallDesktopMin` margin-right: 170px;`}
      }
      &--cu-btn {
        max-width: 360px;
        width: 100%;
      }
      &--cu-form {
        padding: 20px 0;
        &--row-spacing {
          margin: 10px 0;
          &--cu-heading {
            padding: 10px 0;
          }
        }
      }
    }
  }
`;
export default ContactUs;
